import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BookingState } from '@modules/booking/store';
import { Category } from '../categories/categories.models';
import { selectServices } from '../services/services.selectors';

const selectBookingState = createFeatureSelector<BookingState>('booking');

export const selectCategoriesState = createSelector(selectBookingState, (s) => s.categories);

export const selectCategories = createSelector(selectCategoriesState, (s) => s.entities);

export const selectCategoriesWithServices = createSelector(selectCategories, selectServices, (categories, services) => {
  const rootCategoryIdentifier = 'root';
  const servicesMap = new Map();
  const category: Category = {
    uuid: rootCategoryIdentifier,
    title: '',
    categories: [...categories],
    position: 0
  };

  function addServices(category: Category) {
    const categoryCopy = Object.assign({}, category, { services: [] });

    for (const [key, value] of servicesMap) {
      if (key.includes(categoryCopy.uuid)) {
        categoryCopy.services.push(value);
      }
    }

    if (categoryCopy.categories.length > 0) {
      categoryCopy.categories = categoryCopy.categories.map((nestedCategory: Category) => {
        return addServices(nestedCategory);
      });
      return categoryCopy;
    } else {
      return categoryCopy;
    }
  }

  services.forEach((service) => {
    if (service.categoryUuids.length === 0) {
      servicesMap.set(`${service.uuid}:${rootCategoryIdentifier}`, service);
    } else {
      service.categoryUuids.forEach((categoryUuid) => {
        servicesMap.set(`${service.uuid}:${categoryUuid}`, service);
      });
    }
  });

  return addServices(category);
});
